<script lang="ts">
  /**
   * Storage Apps view: shows apps that use browser storage.
   * These apps save data locally in your browser for offline access.
   */
  import { apps } from '$apps/registry';

  // Filter apps that use storage
  $: storageApps = apps.filter(a => a.flags?.usesStorage === true);
</script>

<div class="mb-6">
  <div class="card p-6 bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
    <h2 class="text-lg font-semibold mb-2">Storage Apps</h2>
    <p class="text-sm text-[color:var(--text-muted)] mb-2">
      These apps store data locally in your browser for offline access and persistent state.
      All data remains on your device and is never uploaded to any server.
    </p>
    <p class="text-xs text-[color:var(--text-muted)]">
      💾 Data is stored using browser localStorage and remains available across sessions until you clear your browser data.
    </p>
  </div>
</div>

{#if storageApps.length === 0}
  <div class="card p-6 text-center text-[color:var(--text-muted)]">
    <p>No storage apps available yet.</p>
  </div>
{:else}
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {#each storageApps as app}
      <div class="card p-4 hover:scale-[1.01] transition duration-160">
        <a href={`#${app.route}`} class="block">
          <div class="text-base font-semibold mb-1">{app.name}</div>
          <div class="text-sm text-[color:var(--text-muted)] mb-2">{app.description}</div>
          <div class="text-xs text-blue-600 dark:text-blue-400">💾 Uses browser storage</div>
        </a>
      </div>
    {/each}
  </div>
{/if}

<style>
  .card {
    border-radius: var(--r-lg);
    border: 1px solid var(--border);
    background: var(--surface);
  }
  a {
    text-decoration: none;
    color: var(--text);
  }
  a:hover {
    color: var(--accent);
  }
</style>
